import { Outlet } from "react-router-dom";

const CasinoMobileLayout = () => {
  return (
    <div className="casino-mobile-layout">
      <Outlet />
    </div>
  );
};

export default CasinoMobileLayout;
